import { ApolloError } from '@apollo/client';
import { processGroupCensus, submitGroupCensus } from 'api/operations/censusService';
import { action, makeObservable, runInAction } from 'mobx';
import ICensusReviewPageStore, { CensusReviewDomainParams } from '../iCensusReviewPageStore';

export interface GroupCensusReviewDomainParams extends CensusReviewDomainParams {
  groupId: string;
}

export default abstract class IGroupCensusReviewPageStore extends ICensusReviewPageStore<GroupCensusReviewDomainParams> {
  public async getStatistics(): Promise<void> {
    if (!this._domainData.groupId) {
      throw new Error('Group ID is required');
    }
    this.setIsLoading(true);
    try {
      const { statistics, families, headers } = await processGroupCensus(this._domainData.groupId);
      runInAction(() => {
        this._statistics = statistics;
        this._families = families;
        this._headers = headers;
      });
    } catch (error) {
      runInAction(() => {
        this._setIncompatibilityErrorMsg((error as ApolloError).message);
      });
    }
    this.setIsLoading(false);
  }

  public async onCensusSubmit(): Promise<void> {
    if (!this._domainData.groupId) {
      throw new Error('Group ID is required');
    }
    this.setIsLoading(true);
    await submitGroupCensus(this._domainData.groupId);
    this.setIsLoading(false);
    this.onCompleteRedirect();
  }

  constructor() {
    super();

    makeObservable<IGroupCensusReviewPageStore>(this, {
      getStatistics: action.bound,
      onCensusSubmit: action.bound,
    });
  }
}
